// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://use.typekit.net/fes4uhy.css);"]);
// Module
exports.push([module.id, ".job-description-content__content-text{font-family:open-sans,sans-serif;font-weight:400!important;font-style:normal!important;line-height:1.7}.more-job-title{color:#00a0dd}", ""]);
// Exports
module.exports = exports;
